import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Tags, TagsUpsert } from "../../_objects/tags";

import { ApiService } from "../base/api-base.service";
import { TagsContractService } from "../interfaces/tags-contract.service";
import { NetworkStatusService } from "../network-status.service";
import { TagsOfflineService } from "../offline/tags-offline.service";
import { TagsOnlineService } from "../online/tags-online.service";

@Injectable()
export class TagsService extends ApiService<TagsContractService> implements TagsContractService {
  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: TagsOfflineService,
    protected onlineService: TagsOnlineService
  ) {
    super(networkStatusService, offlineService, onlineService);
  }

  // TG01 /api/v1/tags
  getTags(): Observable<Tags> {
    return this.service.getTags();
  }

  // TG02 /api/tenant/v1/{tenantId}/tags
  upsertTags(tagsUpsert: TagsUpsert): Observable<Tags> {
    return this.service.upsertTags(tagsUpsert);
  }
}
